var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ct-legacy-test-form"},[_c('DynamicTestForm',{ref:"form",attrs:{"test-value":_vm.testValue,"previous-answer":_vm.initialAnswers || {}},on:{"corrected":function($event){return _vm.$emit('corrected', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }